import jaelsImage from "./assets/images/jaels-creations-thumbnail.png";
import caregiverImage from "./assets/images/caregiver-thumbnail.png";
import productManufacturingImage from "./assets/images/product-manufacturing-thumbnail.png";

/**
 * This file is strictly for storing data used on the
 * `/work` page.
 */

var project_data = [
  {
    name: "JAEL'S CREATIONS",
    link: "jaels-creations",
    subText: "A small town's go-to tailor.",
    image: jaelsImage,
    color: "#FFD6CE"
  },
  {
    name: "CAREGIVER TO THE RESCUE",
    link: "caregiver",
    subText: "An in-home personal caregiver.",
    image: caregiverImage,
    color: "#B58AFF"
  },
  {
    name: "PRODUCT MANUFACTURING",
    link: "product-manufacturing",
    subText: "A full-service machine shop.",
    image: productManufacturingImage,
    color: "#CEFFE7"
  }
];

export default project_data;
